module.exports = __webpack_public_path__ + "static/img/yiyasu.965a8ec0.jpg";